// FAQ do portal — fonte única do FAQ da home V2 e da página de dúvidas do V1.
// Conteúdo revisado com o time GCA (documento "FAQ e assistente de ajuda V3",
// 29/09/2026, e "Compilado FAC", 13/10/2026) e alinhado às respostas do assistente
// (v2/V2Assistant/intents.js): ao mudar um texto aqui, revise a resposta
// correspondente do assistente. Ordem das categorias = jornada do cliente.
// `highlight`: perguntas exibidas na home antes de "Ver todas as dúvidas".
const questions = [
  {
    category: 'Compra',
    items: [
      {
        highlight: true,
        question: 'Como faço para comprar os livros com desconto?',
        answer:
          'A compra é feita no <i>site</i> smdireto.com.br, em poucos passos:<ol>' +
          '<li>Peça o voucher à secretaria da escola do aluno.</li>' +
          '<li>Digite o voucher no campo da página inicial e entre com seu cadastro (ou crie um, se for seu primeiro acesso).</li>' +
          '<li>No resumo, confira os livros, o valor com desconto e a forma de entrega.</li>' +
          '<li>Escolha a forma de pagamento e finalize a compra.</li></ol>',
      },
      {
        highlight: true,
        question: 'O que é o voucher e onde encontro o meu?',
        answer:
          'O voucher é o código que libera a compra com o desconto da escola. Ele é fornecido pela escola e é individual por aluno: o voucher de um irmão não vale para o outro. Cada voucher permite uma compra e tem um período de compra definido pela escola. Se você ainda não recebeu o seu, peça à secretaria da escola.',
      },
      {
        question: 'Até quando posso comprar pelo portal?',
        answer:
          'O portal para livros didáticos permanece disponível até julho. Após esse período, os materiais poderão estar disponíveis em parceiros como Amazon e Agrega. Em agosto, o portal entra em preparação para o próximo ano letivo e as vendas ficam indisponíveis. Solicitações de Sistemas de Ensino devem ser feitas por chamado.',
      },
      {
        question: 'Qual é o desconto e onde vejo o valor na hora da compra?',
        answer:
          'O desconto é definido pela escola. Na própria página da compra você vê o valor original e o valor com desconto, antes de pagar.',
      },
      {
        question: 'Meu filho estuda em escola que não está cadastrada na SM. Posso comprar com desconto?',
        answer:
          'Não. No momento, a compra com desconto é exclusiva para pais e/ou responsáveis de alunos de escolas cadastradas na SM.',
      },
      {
        question: 'A escola adotou livros de literatura. Posso comprá-los com desconto?',
        answer:
          'Sim, desde que a escola tenha indicado os livros de literatura na lista de material. Nesse caso, eles aparecem no <i>site</i> para compra.',
      },
    ],
  },
  {
    category: 'Cadastro e senha',
    items: [
      {
        question: 'Esqueci minha senha. Como recupero?',
        answer:
          'Na página de identificação do <i>site</i>, use o recurso “Esqueci minha senha” e digite o <i>e-mail</i> cadastrado. O sistema enviará para esse <i>e-mail</i> um link para você cadastrar uma nova senha.<br>' +
          'Se a sua conta foi criada pelo login com o Google e você nunca cadastrou uma senha, ao tentar entrar com <i>e-mail</i> e senha o sistema envia automaticamente o link para você criar a sua. Se preferir, continue entrando com o Google.',
      },
      {
        question: 'Já tenho cadastro no site da SM. Posso usá-lo para comprar os livros?',
        answer:
          'Sim. Caso já tenha cadastro, não é necessário criar um novo. Você pode utilizar o mesmo usuário e senha. Aproveite para atualizar seus dados, se necessário.',
      },
      {
        question: 'Estou com dificuldade para me cadastrar ou comprar. Como peço ajuda?',
        answer:
          'Se você já tem conta, abra um chamado na área de atendimento da sua conta e descreva sua dificuldade. ' +
          'Se não consegue se cadastrar ou acessar sua conta, preencha o ' +
          '<a href="https://app.pipefy.com/public/form/4k5tgRPD" target="_blank" rel="noopener noreferrer">formulário de atendimento</a>. ' +
          'Nossa equipe entrará em contato, se necessário.',
      },
    ],
  },
  {
    category: 'Pagamento',
    items: [
      {
        highlight: true,
        question: 'Quais são as formas de pagamento?',
        answer:
          'São três opções: PIX e boleto bancário, ambos à vista, e cartão de crédito sem juros. Também é possível pagar com dois cartões.<br>' +
          'No cartão, o número de parcelas depende do mês da compra:<ul>' +
          '<li>novembro e dezembro: até 12 vezes;</li>' +
          '<li>janeiro: até 10 vezes;</li>' +
          '<li>fevereiro e março: até 8 vezes;</li>' +
          '<li>abril a outubro: até 3 vezes.</li></ul>' +
          'Algumas escolas têm condição própria: as parcelas disponíveis aparecem na hora do pagamento.<br>' +
          'No boleto, depois do pagamento, a confirmação depende da compensação bancária, que pode levar até 3 dias úteis.',
      },
      {
        question: 'Como pago com PIX ou boleto e o que faço se o PIX expirar?',
        answer:
          'No PIX, o QR Code e a chave copia-e-cola aparecem na tela com o tempo de validade. Se expirar, abra o pedido em Meus pedidos e use “Ver chave PIX” para gerar outra. No boleto, enquanto o pedido estiver “Aguardando pagamento”, a 2ª via fica em Meus pedidos, no botão “2ª via de boleto”.',
      },
      {
        question: 'Meu pagamento foi recusado. O que fazer?',
        answer:
          'A recusa vem da operadora do cartão (limite, dados divergentes ou análise antifraude), não do <i>site</i>. Confira com o seu banco e tente novamente.',
      },
    ],
  },
  {
    category: 'Entrega',
    items: [
      {
        question: 'Onde encontro a nota fiscal?',
        answer:
          'No detalhe do pedido, no botão “Baixar NF”, depois que o pedido é faturado. Se o pedido ainda estiver em processamento, aguarde.',
      },
      {
        highlight: true,
        question: 'Como e quando vou receber meus livros?',
        answer:
          'A forma de entrega é definida pela sua escola em contrato com a SM. Existem três modelos:<ul>' +
          '<li><b>Entrega imediata:</b> você retira os livros na escola logo após a compra, no prazo que a escola informar.</li>' +
          '<li><b>Entrega na escola:</b> os livros são enviados para a escola, que informa a data de retirada.</li>' +
          '<li><b>Entrega na sua casa:</b> os livros são enviados ao endereço que você informar. A estimativa de prazo aparece no resumo, antes do pagamento. Depois do envio, o rastreio fica disponível em “Ver detalhes” do pedido.</li></ul>' +
          'Antes de pagar, confira no resumo do pedido qual é a entrega da sua escola.',
      },
      {
        question: 'Onde acompanho meu pedido?',
        answer:
          'Acesse Meus pedidos depois de entrar na sua conta. Lá você vê o status de cada pedido. Com o pagamento confirmado, o pedido entra em preparação. Entrega imediata ou na escola: a escola informa a data de retirada. Entrega na sua casa: o rastreio fica disponível em “Ver detalhes” do pedido.',
      },
      {
        question: 'Posso ir à SM retirar os livros?',
        answer:
          'Não. Os livros não são retirados na SM: a entrega segue o modelo definido pela sua escola (imediata, na escola ou na sua casa).',
      },
    ],
  },
  {
    category: 'Cancelamento e troca',
    items: [
      {
        highlight: true,
        question: 'Fiz a compra, mas desisti. Como cancelo?',
        answer:
          'Você pode solicitar o cancelamento em até 7 dias úteis, contados da data de recebimento do produto. Para solicitar, abra um chamado na área de atendimento da sua conta.<br>' +
          'O cancelamento não é troca de produto. Se o livro chegou com problema, veja a pergunta sobre troca.',
      },
      {
        question: 'Quando posso pedir a troca de um livro?',
        answer:
          'A troca se aplica quando o produto for entregue com avaria, com erro operacional ou de gráfica. Você tem até 30 dias corridos, após a data de recebimento, para reportar.',
      },
      {
        question: 'Recebi um livro errado. Como troco?',
        answer:
          'Para solicitar a troca, envie um <i>e-mail</i> para smdireto@grupo-sm.com. Informe o número do pedido e o título recebido.',
      },
    ],
  },
  {
    category: 'Livros adaptados',
    items: [
      {
        question: 'Como solicito livros adaptados para alunos com Necessidades Educacionais Especiais (NEEs)?',
        answer:
          'A SM oferece livros adaptados para alunos com Necessidades Educacionais Especiais (NEEs) nos formatos livro ampliado e PDF. A solicitação deve ser feita pelo <i>e-mail</i> livrosespeciais@grupo-sm.com.',
      },
    ],
  },

  {
    category: 'Fale Conosco',
    items: [
      {
        question: '',
        answer: '',
      },
    ],
  },
]

export default questions
